<template>
  <aside class="promo-config">
    <div class="config-body">
      <section class="config-section">
        <div class="section-row">
          <label class="section-label">裂变商品原图</label>
        </div>
        <div class="upload-box" :class="{ active: workbench.fission.preview }" @click="triggerFissionUpload">
          <input
            ref="fileFission"
            type="file"
            style="display: none"
            accept="image/*"
            @change="onFissionFile"
          />
          <template v-if="workbench.fission.preview">
            <img
              :src="workbench.fission.preview"
              class="preview-img"
              style="object-fit: contain; max-height: 160px"
            />
            <div class="upload-tip">点击更换商品图</div>
          </template>
          <template v-else>
            <div class="upload-plus">+</div>
            <div class="upload-tip">点击上传新商品图</div>
            <div class="upload-desc">（不同颜色或型号）</div>
          </template>
        </div>
      </section>

      <section class="config-section">
        <div class="section-row">
          <label class="section-label">裂变提示词</label>
          <span class="text-dim tiny">控制替换与融合效果</span>
        </div>
        <div class="textarea-wrap">
          <textarea
            v-model="workbench.fission.prompt"
            rows="6"
            class="section-textarea"
            placeholder="例如：保持参考背景图的光影与场景布局，将画面中的核心产品替换为我上传的这款新商品，自然融合..."
          ></textarea>
        </div>
      </section>
    </div>

    <div class="config-footer">
      <button
        class="primary-btn"
        :disabled="workbench.fission.loading || !workbench.fission.image || !workbench.fission.items.length"
        @click="workbench.generateFissionAll"
      >
        {{ workbench.fission.loading ? '裂变生成中...' : '开始批量裂变' }}
      </button>
      <p class="footer-hint">将基于选中的 {{ workbench.fission.items.length }} 张宣传图生成</p>
    </div>
  </aside>
</template>

<script setup>
import { ref } from 'vue'
import { useWorkbenchStore } from '@/stores/useWorkbenchStore'

const workbench = useWorkbenchStore()
const fileFission = ref(null)

const triggerFissionUpload = () => {
  fileFission.value?.click()
}

const onFissionFile = async (event) => {
  const file = event.target.files?.[0]
  if (!file) {
    return
  }
  await workbench.setFissionFile(file)
  event.target.value = ''
}
</script>
